import { Person } from "@mui/icons-material";
import { Avatar, Box, Grid, useTheme } from "@mui/material";
import React from "react";

export const User = ({ msg }) => {
  const theme = useTheme();

  return (
    <Grid container sx={{ marginTop: 2, justifyContent: 'flex-end' }}>
      <Grid item md={11.5} xs={11}>
        <Box
          sx={{
            backgroundColor: theme.palette.mode === 'dark' ? '#00579a' : 'dodgerblue',
            maxWidth: '75%',
            color: 'white',
            padding: 1,
            marginRight:2,
            borderRadius: 2,
            float: 'right',
            textAlign: 'left',
          }}
        >
          <div dangerouslySetInnerHTML={{ __html: msg }} />
        </Box>
      </Grid>
      <Grid item md={0.5} xs={1} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Avatar
          sx={{
            backgroundColor: theme.palette.primary.main,
            float: 'right',
            color: theme.palette.mode === 'dark' ? 'black' : 'white',
          }}
        >
          <Person />
        </Avatar>
      </Grid>
    </Grid>
  );
};
